module.exports = __webpack_public_path__ + "06aa5a0b03c3f81e01d0092b5ff59d80.svg";